<template>
  <keep-alive>
    <router-view @radio="handleRadio"></router-view>
  </keep-alive>
  <MusicPlayer v-if="isFirstPage" />
</template>

<style>
.modal-backdrop.fade.show {
  display: none !important;
}
</style>

<script>
import MusicPlayer from "./components/MusicPlayer.vue";

export default {
  name: "App",
  data() {
    return {
      playMusic: window.localStorage.getItem('playMusic'),
      isFirstPage: this.$route.path === '/' // مقدار اولیه با توجه به مسیر فعلی
    };
  },
  methods: {
    handleRadio(value) {
      this.playMusic = value;
    },
  },
  watch: {
    '$route'(to) {
      this.isFirstPage = to.path === '/'; // بررسی مسیر جدید
    }
  },
  components: {
    MusicPlayer
  }
};
</script>
